import React, { useState } from "react";
import {
  characterCountInString,
  findSecondaryIndexInHead,
  createCharTimes
} from "./helpers";
import styles from "./styles.module.scss";

interface Partitions {
  [partition: string]: string[][];
}

interface DynamoTable {
  head: string[];
  rows: string[][];
}

const Table: React.FC<DynamoTable> = ({ head, rows }) => {
  const [_selectedPK, setSelectedPK] = useState<string | null>(null);

  const selectedPK = head[0] === "" ? null : _selectedPK;

  let primaryKeyIndex = 0;
  let secondaryKeyIndex: number | null = null;
  let secondaryKeyName: string | null = null;

  const findSecondaryIndex = () => {
    if (selectedPK && head[primaryKeyIndex]) {
      const pkLevel = characterCountInString("#", head[primaryKeyIndex]);
      secondaryKeyIndex = findSecondaryIndexInHead(
        head,
        createCharTimes("$", pkLevel)
      );
      secondaryKeyName = head[secondaryKeyIndex];
      return secondaryKeyIndex;
    }
    return -1;
  };

  if (selectedPK) {
    primaryKeyIndex = head.findIndex(cell => cell === selectedPK);
    secondaryKeyIndex = findSecondaryIndex();
  }

  const partitions: Partitions = {};

  // throw each row to partition
  rows.forEach(row => {
    const pk = row[primaryKeyIndex];
    if (pk) {
      let rowCopy = [...row];
      const newKeyPairs = [rowCopy[primaryKeyIndex]];
      if (secondaryKeyIndex > -1 && secondaryKeyIndex !== null) {
        newKeyPairs.push(rowCopy[secondaryKeyIndex]);
      }
      rowCopy[primaryKeyIndex] = null;
      rowCopy[secondaryKeyIndex] = null;

      rowCopy = rowCopy.filter(cell => cell !== null);

      rowCopy = [...newKeyPairs, ...rowCopy];

      if (pk in partitions) {
        partitions[pk].push(rowCopy);
      } else {
        partitions[pk] = [rowCopy];
      }
    }
  });

  return (
    <>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              {[
                ...(selectedPK === null ? [] : [selectedPK]),
                ...(secondaryKeyName === null ? [] : [secondaryKeyName]),
                ...head.filter(
                  cell => cell !== selectedPK && cell !== secondaryKeyName
                )
              ].map((cell, i) => {
                return (
                  <th key={cell + i}>
                    {cell.startsWith("#") ? (
                      <a onClick={() => setSelectedPK(cell)}>{cell}</a>
                    ) : (
                      <span>{cell}</span>
                    )}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {Object.entries(partitions).map(([partitionKey, partitionRows]) => {
              return partitionRows
                .sort((a, b) => a[1] && b[1] && a[1].localeCompare(b[1]))
                .map((partitionRow, i) => (
                  <tr key={i}>
                    {i === 0 && (
                      <td rowSpan={partitionRows.length}>{partitionKey}</td>
                    )}
                    {partitionRow.slice(1).map((cell, i) => (
                      <td key={cell + i}>{cell}</td>
                    ))}
                  </tr>
                ));
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Table;
